var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout layout_inner"},[_c('IeUsersMessage'),_c('Header',{attrs:{"dashboard":"","scroll-position":_vm.scrollPosition}}),_c('main',{staticClass:"layout__main"},[_c('nuxt')],1),_c('Footer',{attrs:{"dashboard":""}}),_c('Cookies'),_c('NoConnectionNotification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }